<template>
    <div id="EstimationsWrapper">
        <div id="EstimationTopContainer">
            <div id="EstimationSelectionContainer">
                <div><img :class="{ 'Button': true, 'TriangleBtnVisible': SelectedMikomiIndex > 0 }" style="visibility: hidden;" width="32" height="32" src="../assets/Icon_Triangle_Left.svg" /></div>
                <GenericDropdown style="width: 300px;" :options="EstimationList" :OnChange="OnSelectEstimation"  />
                <div><img :class="{'Button': true, 'TriangleBtnVisible': SelectedMikomiIndex < EstimationList.length - 1 }" style="visibility: hidden; transform: rotateY(180deg);" width="32" height="32" src="../assets/Icon_Triangle_Left.svg" /></div>
                <div>
                    <div class="Button ButtonNormal NoSelect" @click="OpenResultDetails">
                        実績ディテール
                    </div>
                </div>
            </div>
            <div id="EstimationDataFilterContainer" v-if="IsNewEstimationVisible === false">
                <div class="EstimationFilter">
                    <span>時間枠</span>
                    <GenericMultiDropdown style="direction: rtl;" ref="TimelineFilter" :-input-placeholder="''" :options="TimelineFilterOptions" :-allow-multiple=true :-on-change="OnTimelineFilterChange"/>
                </div>
                <div class="EstimationFilter">
                    <span>チーム</span>
                    <GenericMultiDropdown style="direction: rtl;" ref="TeamFilter" :-input-placeholder="''" :options="TeamFilterOptions" :-allow-multiple=true :-on-change="OnTeamFilterChange" />
                </div>
            </div>
        </div>
        <div id="EstimationBottomContainer" v-if="IsNewEstimationVisible === false">
            <div id="EstimationsTeamsContainer">
                <!-- SEPARATE HEADERS FROM SCROLLABLE CONTAINERS -->
                <div class="EstimationsDataHeader" style="min-height: 48px; max-height: 48px;">&nbsp;</div>
                <div id="LeftSideScrollContainer">
                    <div class="EstimationsTeamEntry">
                        <div class="EstimationTeamName">トイホビー</div>
                        <div class="EstimationTeamData">
                            <div v-if="IsTeamFiltered('フィギュア')" style="background-color: #B7DEE8;">売上（フィギュア）</div>
                            <div v-if="IsTeamFiltered('フィギュア')" style="background-color: #B7DEE8;">総益仮</div>
                            <div v-if="IsTeamFiltered('フィギュア')" style="background-color: #B7DEE8;">総益仮(率)</div>
                            <div v-if="IsTeamFiltered('プラモ')" style="background-color: #FDE9D9;">売上（プラモ）</div>
                            <div v-if="IsTeamFiltered('プラモ')" style="background-color: #FDE9D9;">総益仮</div>
                            <div v-if="IsTeamFiltered('プラモ')" style="background-color: #FDE9D9;">総益仮(率)</div>
                            <div v-if="IsTeamFiltered('デジタル')" style="background-color: #D8E4BC;">売上（デジタル414）</div>
                            <div v-if="IsTeamFiltered('デジタル')" style="background-color: #D8E4BC;">総益仮</div>
                            <div v-if="IsTeamFiltered('デジタル')" style="background-color: #D8E4BC;">総益仮(率)</div>
                            <div v-if="IsTeamFiltered('XPNA')" style="background-color: #dd9999;">売上（XPNA）</div>
                            <div v-if="IsTeamFiltered('XPNA')" style="background-color: #dd9999;">総益仮</div>
                            <div v-if="IsTeamFiltered('XPNA')" style="background-color: #dd9999;">総益仮(率)</div>
                            <div style="background-color: #FFFF00;">売上（TTL）</div>
                            <div style="background-color: #FFFF00;">総益仮</div>
                            <div style="background-color: #FFFF00;">総益仮(率)</div>
                            <div>総益</div>
                            <div>営業利益</div>
                            <div>営業利益率</div>
                            <div>純利益</div>
                            <div>在庫</div>
                        </div>
                    </div>
                    <div class="EstimationsTeamEntry">
                        <div class="EstimationTeamName">ゲーム開発</div>
                        <div class="EstimationTeamData">
                            <div>売上</div>
                            <div>総益仮</div>
                            <div>総益仮(率)</div>
                            <div>総益</div>
                            <div>営業利益</div>
                            <div>営業利益率</div>
                            <div>純利益</div>
                            <div>在庫</div>
                        </div>
                    </div>
                    <div class="EstimationsTeamEntry">
                        <div class="EstimationTeamName">3部TTL</div>
                        <div class="EstimationTeamData">
                            <div>売上</div>
                            <div>総益仮</div>
                            <div>総益仮(率)</div>
                            <div>総益</div>
                            <div>営業利益</div>
                            <div>営業利益率</div>
                            <div>純利益</div>
                            <div>在庫</div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="EstimationsDataContainer">
                <div id="TimelineScrollContainer" class="EstimationsDataHeader EstimationsDataHeaderPadding">
                    <template v-for="TimeEntry in TimelineEntries" :key="TimeEntry.label">
                        <div class="EstimationsDataTimelineEntry">
                            <div style="height: 21px; border-bottom: 1px solid black;">{{ TimeEntry.label }}</div>
                            <div class="" style="display: flex; height: 100%;">
                                <template v-for="entry in TimelineContent" :key="entry.label">
                                    <div v-if="entry.label !== '見込' && entry.label !== '実績' || entry.label === '見込' && TimeEntry.month >= (this.CurrentMikomiDate.getMonth() + 1) || entry.label === '実績' && TimeEntry.month < (this.CurrentMikomiDate.getMonth() + 1)" class="EstimationsDataEntry" :style="`background-color:${entry.color};`">
                                        {{ entry.label }}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
                <div id="MikomiDataContainer">
                    <MikomiContainer v-if="CurrentMikomi !== null" :TeamFilter="TeamEntries" :Mikomi="CurrentMikomi" :FilteredTimeLine="TimelineEntries"  :MikomiCreationDate="CurrentMikomiDate"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GenericMultiDropdown from '@/components/GenericMultiDropdown.vue';
import GenericDropdown from '@/components/GenericDropdown.vue';
import axios from 'axios';
import MikomiContainer from '@/components/MikomiContainer.vue';

export default{
    components:{
        GenericMultiDropdown,
        GenericDropdown,
        MikomiContainer,
    },
    mounted(){
        this.$IsSharePoint.value = true;
        this.API_KEY = this.$route.query.apiKey;
        this.CurrentMonth = new Date().getMonth() + 1;

        this.SetUpScroll();

        for (let i = 0; i < this.TimelineFilterOptions.length; i++)
        {
            this.$refs.TimelineFilter.ToggleItem(this.TimelineFilterOptions[i].label);
        }

        this.$refs.TeamFilter.ToggleItem(this.TeamFilterOptions[1].label);
        this.$refs.TeamFilter.ToggleItem(this.TeamFilterOptions[0].label);

        this.TimelineEntries = [];
        for (let i = 0; i < this.TimelineOptions.length; i++)
        {
            if (this.TimelineOptions[i].Check(this.TimelineFilterOptions) === true)
            {
                this.TimelineEntries.push({ label: this.TimelineOptions[i].label, month: this.TimelineOptions[i].month });
            }
        }
        console.log("timeline entries", this.TimelineEntries);

        // this.UpdateTimelineContent();
        this.GetAvailableMikomiInformation();
    },
    methods:{
        SetUpScroll()
        {
            setTimeout(()=>{
                this.DataScrollContainer = document.getElementById('MikomiDataContainer');
                if (this.DataScrollContainer !== null)
                {
                    this.DataScrollContainer.addEventListener('scroll', this.OnDataScroll);
                    this.TimelineScrollContainer = document.getElementById('TimelineScrollContainer');
                    this.LeftSideScrollContainer = document.getElementById('LeftSideScrollContainer');
                }                
            }, 100);
        },
        OnDataScroll(event)
        {
            this.LeftSideScrollContainer.scrollTop = event.target.scrollTop;
            this.TimelineScrollContainer.scrollLeft = event.target.scrollLeft;
        },
        async GetAvailableMikomiInformation()
        {
            if (this.IsPullingMikomiList === false)
            {
                this.IsPullingMikomiList = true;
                const data = {
                    API_KEY: this.API_KEY,
                };

                const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}sp/estimation/list`, data)
                .then(async response => {
                    return response.data;
                })
                .catch(error => {
                    console.error(error);
                    this.$HandleBadRequest(error.response.status, error.response.data);
                });

                this.IsPullingMikomiList = false;
                this.EstimationList = [];
                console.log('mikomi list', result);

                if (result !== null &&
                    result !== undefined)
                {
                    for (let i = 0; i < result.length; i++)
                    {
                        this.EstimationList.push({label: result[i].name, value: result[i].id });
                    }

                    if (this.EstimationList.length === 0)
                    {
                        this.EstimationList.push({label:'見込比較はまだありません。', value: -1});
                    }

                    this.SelectedMikomiID = this.EstimationList[0].value;
                    this.SelectedMikomiIndex = 0;
                    this.GetMikomi();
                }
            }
        },
        async GetMikomi()
        {
            if (this.SelectedMikomiID === -1)
            {
                return;
            }

            this.IsPullingMikomiID = this.SelectedMikomiID;

            const data = {
                API_KEY: this.API_KEY,
                ID: this.SelectedMikomiID,
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}sp/estimation`, data)
            .then(async response => {
                return response.data;
            })
            .catch(error => {
                console.error('get mikomi error', error);
            });

            // if (result !== null &&
            //     result !== undefined &&
            //     result !== '' &&
            //     result.ID === this.IsPullingMikomiID)
            if (result.ID === this.IsPullingMikomiID)
            {
                console.log('Mikomi received', result);
                
                this.CurrentMikomiDate = new Date(result.Mikomi.created_at);
                // console.log('Mikomi created at', this.CurrentMikomiDate);
                this.CurrentMikomi = result.Mikomi.data;
                this.IsPullingMikomiID = -1;

                this.UpdateTimelineContent();
            }
        },
        OpenResultDetails()
        {
            this.$router.push({
                path: '/sp_estimations/details',
                query: { apiKey: this.API_KEY }
            });
        },
        OnSelectEstimation(event)
        {
            console.log('[EstimationsPage](OnSelectEstimation) Event', event);
            this.SelectedMikomiID = event.target.options[event.target.options.selectedIndex].value;
            this.SelectedMikomiIndex = event.target.options.selectedIndex;
            this.GetMikomi();
        },
        UpdateTimelineContent()
        {
            this.TimelineContent = [];

            console.log('Current mikomi', this.CurrentMikomi);
            let timelineSet = new Set();
            for (let i = 0; i < this.CurrentMikomi.length; i++)
            {
                const month = this.CurrentMikomi[i];
                for (let j = 0; j < month.Keikaku.length; j++)
                {
                    // if undefined, it's mikomi so we don't have to continue
                    if (month.Keikaku[j].revision === undefined)
                    {
                        break;   
                    }
                    
                    const name = this.KeikakuRevisionToName(month.Keikaku[j].revision, new Date(month.Keikaku[j].added_at));
                    if (timelineSet.has(name) === false)
                    {
                        timelineSet.add(name);
                        this.TimelineContent.push({ label: name, color: this.KeikakuRevisionToColor(month.Keikaku[j].revision)});
                    }
                }
            }

            // ToDo: Continue here
            //       Have to find out how to add
            //       実績 and 差額
            // For making the design, we add both for now
            for (let i = 0; i < this.FixedOptions.length; i++)
            {
                this.TimelineContent.push(this.FixedOptions[i]);
            }

            // console.log('Updated timeline content', this.TimelineContent);
            // console.log('current month', this.CurrentMonth);
        },
        OnTeamFilterChange(filter)
        {
            this.TeamEntries = [];

            for (let i = 0; i < filter.length; i++)
            {
                this.TeamEntries.push(filter[i].label);
            }
        },
        OnTimelineFilterChange(filter)
        {
            this.TimelineEntries = [];

            for (let i = 0; i < this.TimelineOptions.length; i++)
            {
                if (this.TimelineOptions[i].Check(filter) === true)
                {
                    this.TimelineEntries.push({ label: this.TimelineOptions[i].label, month: this.TimelineOptions[i].month });
                }
            }
        },
        KeikakuRevisionToName(revision, date)
        {
            switch (revision)
            {
                case 0: return `${date.getMonth() + 1}/${date.getDate()} 計画`;
                case 1:
                case 2:
                case 3:
                    return `${date.getMonth() + 1}月見直計画`;

                default: 'NA_計画';
            }
        },
        KeikakuRevisionToColor(revision)
        {
            switch(revision)
            {
                case 0: return '#D8E4BC';
                case 1: return '#FDE9D9';
                case 2: return '#E4DFEC';
                case 3: return '#FFFF99';

                default: '#FF9900';
            }
        },
        IsTeamFiltered(team)
        {
            return this.TeamEntries.includes(team);
        },
    },
    data(){
        return{
            API_KEY: '',
            CurrentMonth: 1,
            IsGettingLatestDataDates: false,
            LatestZaikoUpdate: '',
            LatestKeikakuUpdate: '',
            IsNewEstimationVisible: false,
            TimelineFilterOptions: [
                { label: '月', value: 0 },
                { label: 'Q', value: 1 },
                { label: '上期/下期', value: 2 },
            ],
            TeamFilterOptions: [
                { label: 'フィギュア', value: 0 },
                { label: 'プラモ', value: 1 },
                { label: 'デジタル', value: 2 },
                { label: 'XPNA', value: 3 },
            ],
            TeamEntries: [],
            EstimationDataTypes: [
                { label: '売上'},
                { label: '総益(仮)'},
                { label: '総益率'},
                { label: '総益'},
                { label: '営業利益'},
                { label: '営業利益率'},
                { label: '純利益'},
                { label: '在庫'},
            ],
            TimelineOptions: [
                { label: '1月', month: 1, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '2月', month: 2, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '3月', month: 3, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q1', month: 3, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '4月', month: 4, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '5月', month: 5, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '6月', month: 6, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q2', month: 6, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '上期', month: 6, Check: (filter)=>{
                    return filter.some(item => item.label === '上期/下期');
                }},
                { label: '7月', month: 7, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '8月', month: 8, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '9月', month: 9, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q3', month: 9, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '10月', month: 10, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '11月', month: 11, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '12月', month: 12, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q4', month: 12, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '下期', month: 12, Check: (filter)=>{
                    return filter.some(item => item.label === '上期/下期');
                }},
                // eslint-disable-next-line
                { label: 'TTL', month: 12, Check: (filter)=>{
                    return true;
                }},
            ],
            TimelineEntries: [],
            FixedOptions: [
                { label: '見込', color: '#DAEEF3'},
                { label: '実績', color: '#DAEEF3'},
                { label: '差額', color: '#FFFFFF'},
            ],
            TimelineContent: [],
            SelectedMikomiIndex: 0,
            EstimationList: [],
            ShowNewMikomiPreview: false,
            PreviewMikomi: null,
            SelectedMikomiID: -1,
            IsPullingMikomiList: false,
            IsPullingMikomiID: -1,
            CurrentMikomiDate: null,
            CurrentMikomi: null,
        }
    },
}
</script>